export * from './base.class';

export * from './base.service';

export * from './base.component';
export * from './base-with-dynamic.component';

// export * from './base.module';